import { BiteLogStripeEvent } from './bite_log_stripe_event.js';

export function name(event: BiteLogStripeEvent): string {
  switch (event) {
    case BiteLogStripeEvent.None:
      return 'ok';
    case BiteLogStripeEvent.PaymentIntent:
      return 'payment-intent';
    case BiteLogStripeEvent.PaymentIntentError:
      return 'payment-intent-error';
    case BiteLogStripeEvent.Refund:
      return 'refund';
    case BiteLogStripeEvent.RefundError:
      return 'refund-error';
    case BiteLogStripeEvent.TokenizationError:
      return 'tokenization-error';
    case BiteLogStripeEvent.TerminalDisconnected:
      return 'terminal-disconnected';
  }
}
